module.exports = "/images/gb-ork.svg?72a639972bfbc03766f2963c57d0bcde";